import { render, staticRenderFns } from "./SwiperItemSerie.vue?vue&type=template&id=7b8dc9a7&scoped=true"
import script from "./SwiperItemSerie.vue?vue&type=script&lang=js"
export * from "./SwiperItemSerie.vue?vue&type=script&lang=js"
import style0 from "./SwiperItemSerie.vue?vue&type=style&index=0&id=7b8dc9a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8dc9a7",
  null
  
)

export default component.exports